module.exports = __webpack_public_path__ + "static/private-calendar-header-d4fe140fd832bf0a7749d345af0eefec.png";